<template>
  <div class="pr-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="tableToolsPanel.indexOf('filter')>-1?'隐藏筛选条件':'展开筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="状态" prop="status">
                  <Select v-model="filterModel.status">
                    <Option :value="null">不限</Option>
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.projectRegisterStatus)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="流水号" prop="serialNo">
                  <Input v-model="filterModel.serialNo" placeholder="输入流水号" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="业务编号" prop="orderNumber">
                  <Input v-model="filterModel.orderNumber" placeholder="输入保函编号" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="项目名称" prop="projectName">
                  <Input v-model="filterModel.projectName" placeholder="输入项目名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="建设单位" prop="ownerName">
                  <Input v-model="filterModel.ownerName" placeholder="输入建设单位名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="施工企业" prop="contractorName">
                  <Input v-model="filterModel.contractorName" placeholder="输入施工企业名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="经办机构" prop="guarantorName">
                  <Input v-model="filterModel.guarantorName" placeholder="输入经办机构名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/project-register/add" icon="md-add">新增</Button>
    </div>
    <div class="padding-top-10"></div>
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      :row-class-name="rowClassName"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'pr-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '单据号',
          width: 160,
          key: 'serialNo',
          resizable: true,
        },
        {
          title: '业务编号',
          width: 160,
          key: 'orderNumber',
          resizable: true,
        },
        {
          title: '状态',
          key: 'status',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.$common.projectRegisterStatusColor[params.row.status.toString()]
              }
            }, this.$common.projectRegisterStatus[params.row.status.toString()])
          }
        },
        {
          title: '项目名称',
          width: 240,
          key: 'projectName',
          resizable: true,
        },
        {
          title: '建设单位',
          width: 240,
          key: 'ownerName',
          resizable: true,
        },
        {
          title: '施工单位',
          width: 240,
          key: 'contractorName',
          resizable: true,
        },
        {
          title: '监管单位',
          width: 240,
          key: 'supervisorName',
          resizable: true,
        },
        {
          title: '经办机构',
          width: 240,
          key: 'guarantorName',
          resizable: true,
        },
        {
          title: '中标金额',
          key: 'projectCost',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.projectCost ? Math.round(params.row.projectCost / 100 / 1000) / 10 + '万' : null)
          }
        },
        {
          title: '存储比例',
          key: 'payableRatio',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, Math.round(params.row.payableRatio * 10000) / 100 + '%')
          }
        },
        {
          title: '上报时间',
          key: 'createTime',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.createTime ? this.getMoment(params.row.createTime).format('YYYY-MM-DD') : null)
          }
        },
        {
          title: '操作',
          width: 160,
          fixed: 'right',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                },
                style: {
                  marginLeft: '5px'
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'project-register-detail', params: {orderNumber: params.row.orderNumber, mode: this.$route.params.mode}})
                    }
                  }
                }, null),
              ]),
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        status: null,
        serialNo: null,
        orderNumber: null,
        projectName: null,
        contractorName: null,
        ownerName: null,
        guarantorName: null,
        supervisorName: null
      }
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    '$route.params.status': function (newVal) {
      this.filterModel.status = newVal
      this.initData()
    }
  },
  mounted () {
    if (this.$route.params.status !== null) {
      this.filterModel.status = this.$route.params.status
    }
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    rowClassName (row) {
      let auditTime = row.auditTime
      if (!auditTime || !row.guaranteeId) {
        return null
      }
      let daysAfterAudit = this.$moment().diff(this.$moment(row.auditTime), 'days')
      if (daysAfterAudit >= 30) {
        return 'alert-row'
      } else if (daysAfterAudit >= 15) {
        return 'warning-row'
      } else {
        return 'normal-row'
      }
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    getMoment (dt) {
      return moment(dt)
    },
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.ProjectRegister.listProjectRegisters(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
  }
}
</script>

<style lang="less" scoped>
.pr-list {
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
 <style lang="less">
 .pr-list {
  .ivu-table .warning-row td{
    background-color: #feecd2;
  }
  .ivu-table .alert-row td{
    background-color: #ffd9cf;
  }
}
</style>